/**
 * @flow
 * @relayHash c8f86743ce8af69d36b8541f51f84310
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ArchiveReportMutationVariables = {|
  input: {
    reportId: string;
    clientMutationId?: ?string;
  };
|};

export type ArchiveReportMutationResponse = {|
  +archiveReport: ?{|
    +report: ?{|
      +id: string;
    |};
  |};
|};
*/


/*
mutation ArchiveReportMutation(
  $input: ArchiveReportInput!
) {
  archiveReport(input: $input) {
    report {
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ArchiveReportInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveReportMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ArchiveReportInput!"
          }
        ],
        "concreteType": "ArchiveReportPayload",
        "name": "archiveReport",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "name": "report",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ArchiveReportMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ArchiveReportInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ArchiveReportMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ArchiveReportInput!"
          }
        ],
        "concreteType": "ArchiveReportPayload",
        "name": "archiveReport",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Report",
            "name": "report",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ArchiveReportMutation(\n  $input: ArchiveReportInput!\n) {\n  archiveReport(input: $input) {\n    report {\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/ArchiveReportMutation.graphql.js